import type { AssignmentDraft } from './assignments';

export interface ChangeSummary {
  addedRoles: string[];
  removedRoles: string[];
  addedExtras: string[];
  removedExtras: string[];
}

const minus = (from: readonly string[], without: readonly string[]): string[] => {
  const excluded = new Set(without);
  return from.filter((id) => !excluded.has(id));
};

// Sets, not sequences: reordering the marks changes nothing, so it never enables «Guardar».
export function summarize(before: AssignmentDraft, after: AssignmentDraft): ChangeSummary {
  return {
    addedRoles: minus(after.roles, before.roles),
    removedRoles: minus(before.roles, after.roles),
    addedExtras: minus(after.extraPermissions, before.extraPermissions),
    removedExtras: minus(before.extraPermissions, after.extraPermissions),
  };
}

export function hasChanges(summary: ChangeSummary): boolean {
  return (
    summary.addedRoles.length > 0 ||
    summary.removedRoles.length > 0 ||
    summary.addedExtras.length > 0 ||
    summary.removedExtras.length > 0
  );
}
